import { Injectable } from '@angular/core';
import * as it from '../services/localization/localizationService_it.json';
import * as es from '../services/localization/localizationService_es.json';
import * as hu from '../services/localization/localizationService_hu.json';
import * as nl from '../services/localization/localizationService_nl.json';
import * as fr from '../services/localization/localizationService_fr.json';
import * as en from '../services/localization/localizationService_en.json';
import * as de from '../services/localization/localizationService_de.json';

@Injectable()

export class LocalizationService {

  private languages = ["IT", "ES", "HU", "NL", "FR", "EN", "UK", "DE", "AT"];
  private lang = "IT"

  constructor()
  {
  }

  currLang() : string
  {
    return this.lang;
  }

  setLang(lg :string)
  {
    if (typeof(lg) !== "undefined" && lg !== "")
    {
      lg = lg.toUpperCase();
      if (this.languages.indexOf(lg) != -1)
        this.lang = lg;
    }
  }

  get(key : string): string
  {
    let data = null;
    switch(this.lang)
    {
      case "IT":
        data = it;
        break;
      case "ES":
        data = es;
        break;
      case "HU":
        data = hu;
        break;
      case "NL":
        data = nl;
        break;
      case "FR":
        data = fr;
        break;
      case "EN":
      case "UK": //path per filiale inglese
        data = en;
        break;
      case "AT":
      case "DE":
        data = de;
        break;

    }
    return data != null ? data[key] : key;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/localization.service.ts